import { create } from "zustand";

export const useAuthStore = create((set) => ({
  token: null,

  setToken: (newToken) => {
    set((state) => {
      return {
        ...state,
        token: newToken,
      };
    });
  },
  
  logout: () => set((state) => {
    return {
      ...state,
      token: null,
    };
  }),
}));